var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from './icon';
export var IconAdd = React.forwardRef(function (props, ref) { return (_jsxs(Icon, __assign({ viewBox: "0 0 24 24", ref: ref, "data-name": "IconAdd" }, props, { children: [_jsx("path", { fill: "none", d: "M0 0h24v24H0z" }), _jsx("path", { fill: "none", d: "M0 0h24v24H0z" }), _jsx("path", { d: "M21 11h-8V3h-2v8H3v2h8v8h2v-8h8v-2z" })] }))); });
IconAdd.displayName = 'IconAdd';
export default IconAdd;
